import React from 'react';
import { Helmet } from 'react-helmet-async';

import { makeUrl } from 'src/shared/utils/url';

interface CanonicalLinkProps {
  pathname: string;
}

const CanonicalLink = ({ pathname }: CanonicalLinkProps) => (
  <Helmet>
    <link href={makeUrl(pathname).href} rel="canonical" />
  </Helmet>
);

export { CanonicalLink };
